module.exports = __webpack_public_path__ + "img/guanwang_icon_jiantou_white.56e73668.svg";